<ng-container *transloco="let t">
  <div class="flex flex-col">
    <!-- Label -->
    @if (props.label) {
      <label [for]="id" class="font-semibold">
        {{ props.label }}
        @if (props.required) {
          <span class="text-red-500">*</span>
        }
      </label>
    }

    <!-- Tree component -->
    <p-tree
      [id]="id"
      [value]="treeNodes"
      selectionMode="checkbox"
      [(selection)]="selectedNodes"
      (selectionChange)="onSelectionChange()"
      [class.ng-invalid]="isInvalid"
      [class.ng-dirty]="formControl.dirty"
      [class.opacity-50]="formControl.disabled"
      [class.pointer-events-none]="formControl.disabled"
      styleClass="w-full"
    ></p-tree>

    <!-- Description -->
    @if (props.description) {
      <div class="text-sm text-surface-600 dark:text-surface-300 mt-1">
        {{ props.description }}
      </div>
    }

    <!-- Error messages -->
    <div *ngIf="isInvalid" class="text-red-500 text-sm mt-1">
      <span *ngIf="formControl.errors?.['required']">
        {{ t("app.formly-types.validationMessages.fieldRequired") }}
      </span>
    </div>
  </div>
</ng-container>
